import { Directive, ElementRef, HostListener, Input, OnInit, Renderer2 } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Directive({
  selector: '[wsbAppControlValidator]',
  standalone: false
})
export class ControlValidatorDirective implements OnInit {
  @Input() fc: UntypedFormControl;

  constructor(private renderer: Renderer2, private elmRef: ElementRef) {}

  // The following code has been disabled because it create a bug on validation form
  // I don't know why it  has been write
  // @HostListener('click')
  // removeInvalidStatus() {
  //   this.fc.setErrors(null);
  //   this.renderer.removeClass(this.elmRef.nativeElement, 'is-invalid');
  // }

  @HostListener('blur')
  validateFormControl() {
    this.fc.updateValueAndValidity({ onlySelf: true, emitEvent: true });
    if (this.fc.invalid && this.fc.touched) {
      this.renderer.addClass(this.elmRef.nativeElement, 'is-invalid');
    }
  }

  ngOnInit(): void {
    this.fc.valueChanges.pipe(debounceTime(300), distinctUntilChanged()).subscribe(() => {
      this.fc.updateValueAndValidity();
      if (this.fc.invalid && this.fc.touched) {
        this.renderer.addClass(this.elmRef.nativeElement, 'is-invalid');
      } else {
        this.renderer.removeClass(this.elmRef.nativeElement, 'is-invalid');
      }
    });
  }
}
